<template><div v-if="visible" class="modal-overlay"><div class="modal-content"><h3>请填写视频流地址</h3><input
        type="text"
        v-model="streamUrl"
        placeholder="请输入视频流地址"
        class="stream-input"
        @keyup.enter="handleConfirm"
      /><div class="modal-actions"><button @click="handleCancel" class="cancel-btn">取消</button><button @click="handleConfirm" class="confirm-btn">确定</button></div></div></div></template><script>export default {
  name: 'VideoStreamModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      streamUrl: ''
    }
  },
  methods: {
    handleConfirm() {
      if (this.streamUrl.trim()) {
        this.$emit('confirm', this.streamUrl.trim())
        this.streamUrl = ''
      }
    },
    handleCancel() {
      this.streamUrl = ''
      this.$emit('cancel')
    }
  }
}</script><style scoped>.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #333;
}

.stream-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.stream-input:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn,
.confirm-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}

.cancel-btn {
  background-color: #f5f5f5;
  color: #333;
}

.cancel-btn:hover {
  background-color: #e6e6e6;
}

.confirm-btn {
  background-color: #1890ff;
  color: white;
}

.confirm-btn:hover {
  background-color: #40a9ff;
}</style>